import React from 'react'
import styled from "@emotion/styled"
import { useSpring, animated, config } from "react-spring";
import BurgerMenu from "./BurgerMenu";
import CollapseMenu from "./CollapseMenu";
import Brand from "./Brand";
import { Link } from "gatsby"

const NavBar = styled.nav`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background: #ffffff;
  z-index: 2;
  font-size: 1.4rem;
`;

const FlexContainer = styled.div`
  max-width: 120rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  margin: auto;
  padding: 0 2rem;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 5rem;
  color: #000000FF;
`;

const NavLinks = styled(animated.ul)`
  justify-self: end;
  list-style-type: none;
  margin: auto 0;

  & a {
    color: #000000FF;
    font-family: Tango;
    font-size: 2.5rem;
    border-bottom: 1px solid transparent;
    margin: 0 1rem;
    -webkit-transition: all 200ms linear 0s;
    -o-transition: all 200ms linear 0s;
    transition: all 200ms linear 0s;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #f80c16;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }
`;

const BurgerWrapper = styled.div`
  margin: auto 0;

  @media (min-width: 769px) {
    display: none;
  }
`;

const Navbar = (props) => {
  
    const linkAnimation = useSpring({
      from: { transform: 'translate3d(0, 30px, 0)', opacity: 0 },
      to: { transform: 'translate3d(0, 0, 0)', opacity: 1 },
      delay: 800,
      config: config.wobbly,
    });
  
    return (
      <>
        <NavBar>
          <FlexContainer>
            <Brand />
            <NavLinks style={linkAnimation}>
              <Link to="/about/" activeStyle={{ textDecoration: "underline solid #f80c16", color: "#f80c16" }}>About</Link>
              <Link to="/work/" activeStyle={{ textDecoration: "underline solid #f80c16", color: "#f80c16" }}>Work</Link>
              <Link to="/blog/" activeStyle={{ textDecoration: "underline solid #f80c16", color: "#f80c16" }}>Blog</Link>
              <Link to="/contact/" activeStyle={{ textDecoration: "underline solid #f80c16", color: "#f80c16" }}>Contact</Link>
            </NavLinks>
            <BurgerWrapper>
              <BurgerMenu
                navbarState={props.navbarState} 
                handleNavbar={props.handleNavbar}
              />
            </BurgerWrapper>
          </FlexContainer>
        </NavBar>
        <CollapseMenu 
          navbarState={props.navbarState} 
          handleNavbar={props.handleNavbar}
        />
     </>
    )
  }
  
export default Navbar